import { render, staticRenderFns } from "./ModelApply.vue?vue&type=template&id=a2492272&scoped=true&"
import script from "./ModelApply.vue?vue&type=script&lang=js&"
export * from "./ModelApply.vue?vue&type=script&lang=js&"
import style0 from "./ModelApply.vue?vue&type=style&index=0&id=a2492272&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2492272",
  null
  
)

export default component.exports